<template>
	<div>
		<div class="row justify-center q-my-md" v-if="loading">
			<q-spinner-dots color="primary" size="3em"/>
		</div>
		<div v-else>
			<div class="row justify-between q-col-gutter-sm">
				<div class="col">
					<q-btn @click="showAddAllToWatchlistDialog = true"
						   :label="$t('button.addAllPalletLogsToWatchlist')"
						   color="primary"
					/>
				</div>
				<div class="col col-shrink">
					<search-view-select @input="setSearchDisplayType" palletLogSearch/>
				</div>
			</div>

			<template v-if="palletLogSearchDisplayType === 'teaser'">
				<div class="row q-py-lg q-col-gutter-md">
					<div v-for="object in palletLogs"
						 :key="object.uid"
						 class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
					>
						<veneer-log @click="showLogDetailDialog(object)"
									:emit-log="true"
									:log="object"
									:watchlist-dialog="true"
									:measurement-list-dialog="true"
									:show-active-watchlist-check="true"
									:is-dynamic-watchlist="false"
									:is-public="false"
						/>
					</div>
				</div>
			</template>

			<template v-if="palletLogSearchDisplayType === 'table'">
				<div class="q-py-lg justify-center">
					<veneer-log-table
							@click="showLogDetailDialog"
							:logs="palletLogs"
							:emit-log="true"
					/>
				</div>
			</template>

			<q-dialog v-model="showAddAllToWatchlistDialog" square>
				<q-card>
					<dialog-header dialog-title="watchPallet" @close="showAddAllToWatchlistDialog = false"/>
					<q-card-section>
						<div class="column">
							<div class="col" v-if="user.zohoAuthenticated">
								<customer-select v-model="selectedCustomer" :customer-name="presetCustomerName"/>
							</div>
							<div class="col">
								<watchlist-select v-model="selectedWatchlist"
												  :watchlist-name="presetWatchlistName"
												  :customer="selectedCustomer"
												  :disable="user.zohoAuthenticated && !selectedCustomer"
												  only-static
								/>
							</div>
							<div class="col">
								<q-input type="number"
										 v-model="newPrice"
										 :prefix="$t('label.price')"
										 :suffix="priceUnit"
										 input-class="text-right"
								/>
							</div>
							<div class="col">
								<q-input v-model="newDescription"
										 :placeholder="$t('addDescription')"
										 :disabled="saving"
										 :label="$t('label.comment')"
										 autogrow
								/>
							</div>
						</div>

						<div class="row q-mt-md justify-end">
							<div>
								<q-btn @click="showAddAllToWatchlistDialog = false" :label="$t('button.cancel')" flat/>
							</div>
							<div>
								<q-btn @click="addAllPalletLogsToWatchlist" :label="$t('button.watch')"
									   :loading="saving" color="primary" :disable="disableSave"/>
							</div>
						</div>
					</q-card-section>
				</q-card>
			</q-dialog>

			<q-dialog v-model="logDetailDialogVisible" :full-width="true" square>
				<q-card>
					<dialog-header dialog-title="" :raw-title="true" @close="logDetailDialogVisible = false"/>

					<q-card-section>
						<detail :prop-log="detailLog" :hide-back-link="true"/>
					</q-card-section>
				</q-card>
			</q-dialog>
		</div>
	</div>
</template>

<script>
	import {ADD_TO_WATCHLIST, FETCH_LOGS_BY_PALLET_IDENTIFIERS} from "@/store/actions.type";
	import LogPropertiesResolver from "@/mixins/LogPropertiesResolver";
	import {mapGetters} from "vuex";
	import VeneerLog from "@/components/common/VeneerLog";
	import CustomerSelect from "@/components/zoho/CustomerSelect";
	import WatchlistSelect from "@/components/form/WatchlistSelect";
	import WatchlistPreselection from "@/mixins/WatchlistPreselection";
	import SearchViewSelect from "@/components/form/SearchViewSelect";
	import Teaser from "@/mixins/Teaser";
	import VeneerLogTable from "@/components/common/VeneerLogTable";
	import LogUtility from "@/mixins/LogUtility";
	import DialogHeader from "@/components/dialog/DialogHeader";
	import Detail from "@/views/Detail";
  import {
    SET_PALLET_LOGS_SEARCH_DISPLAY_TYPE,
    SET_PALLET_SEARCH_DISPLAY_TYPE, SET_PALLET_SEARCH_DISPLAY_TYPE_PALLET,
    SET_SEARCH_DISPLAY_TYPE,
    SET_SEARCH_DISPLAY_TYPE_PALLET
  } from "@/store/mutations.type";

	export default {
		name: "PalletLogList",
		components: {
			Detail,
			DialogHeader, VeneerLogTable, Teaser, SearchViewSelect, WatchlistSelect, CustomerSelect, VeneerLog
		},
		mixins: [LogPropertiesResolver, WatchlistPreselection, LogUtility],
		props: {
			pallet: Object
		},
		data() {
			return {
				loading: true,
				saving: false,
				showAddAllToWatchlistDialog: false,
				logDetailDialogVisible: false,
				detailLog: null,
				detailLogIdentifier: null
			}
		},
		computed: {
			...mapGetters(['user', 'palletLogs', 'palletLogSearchDisplayType'])
		},
		async mounted() {
			// load logs
			await this.$store.dispatch(FETCH_LOGS_BY_PALLET_IDENTIFIERS, [this.palletId]);
			this.loading = false;
		},
		methods: {
			async addAllPalletLogsToWatchlist() {
				this.saving = true;
				await this.$store.dispatch(ADD_TO_WATCHLIST, {
					objects: this.palletLogs,
					watchlist: this.selectedWatchlist.uid,
					params: {
						price: this.newPrice,
						description: this.newDescription
					}
				});
				this.saving = false;
				this.showAddAllToWatchlistDialog = false;
				this.$emit('hide');
			},
			showLogDetailDialog(log) {
				this.detailLog = log;
				this.detailLogIdentifier = log.intLogId;
				this.logDetailDialogVisible = true;
			},
      setSearchDisplayType(searchDisplayType) {
        if(searchDisplayType !== this.palletLogSearchDisplayType) {
            this.$store.commit(SET_PALLET_LOGS_SEARCH_DISPLAY_TYPE, searchDisplayType);
        }
      }
		}
	}
</script>